export default __webpack_public_path__ + "static/media/367.e19c28d5.jpg";